module.exports = __webpack_public_path__ + "img/01.b4d5eddc.jpg";